import {ColorRefinementList} from "@/instantsearch/components/ColorRefinementList.tsx";
import {RangeSlider} from "@/instantsearch/components/RangeSlider.tsx";
import {RefinementList} from "@/instantsearch/components/RefinementList.tsx";
import { useEffect, useRef, useState } from "react";
import { DynamicWidgets } from "react-instantsearch";
import { useConfigContext } from "@/ConfigProvider";

import { useViewport } from "@/utils/useViewport";

export default function FilterBox() {
    const {
        algoliaRefinements: { refinementList, hasRefinements }
    } = useConfigContext();

    const { isMobile, isTablet } = useViewport();
    const [showAll, setShowAll] = useState(false);
    const [actualVisibleCount, setActualVisibleCount] = useState(0);
    const containerRef = useRef<HTMLDivElement>(null);

    // Device-based max visible count
    const MAX_VISIBLE = isMobile ? 100 : isTablet ? 5 : 7;

    useEffect(() => {
        if (containerRef.current) {
            // Wir zählen die Panels, die von den Widgets gerendert werden.
            // Da Widgets null zurückgeben, wenn sie leer sind, befinden sich nur aktive Panels im DOM.
            const panels = containerRef.current.querySelectorAll(".algoliaPanel");
            setActualVisibleCount(panels.length);
        }
    }); // Ohne Dependency Array, um nach jedem Render (auch von InstantSearch Updates) zu prüfen

    // 1️⃣ Build actual widget components and filter out nulls
    const allWidgets = refinementList
        .map((item, index) => {
            if (item.display_type === 3) {
                return (
                    <RangeSlider
                        key={index}
                        attribute={item.name}
                        title={item.description}
                    />
                );
            } else if (item.display_type === 9) {
                return (
                    <ColorRefinementList
                        key={index}
                        attribute={item.name}
                        title={item.description}
                        limit={7}
                        showMoreLimit={100}
                        multiple_choices={item.multiple_choices}
                    />
                );
            } else if ([0, 1, 2].includes(item.display_type)) {
                return (
                    <RefinementList
                        key={index}
                        attribute={item.name}
                        title={item.description}
                        limit={7}
                        showMore
                        showMoreLimit={100}
                        multiple_choices={item.multiple_choices}
                    />
                );
            }
            return null; // skip unsupported widgets
        })
        .filter(Boolean); // remove nulls → only real widget components

    const shouldShowToggle = actualVisibleCount > MAX_VISIBLE;
console.log(hasRefinements);
console.log(allWidgets);
    return (
        <div ref={containerRef} className={!showAll ? "filterBox--limited" : "filterBox--unlimited"}>
            <DynamicWidgets>{hasRefinements && allWidgets}</DynamicWidgets>

            {shouldShowToggle && (
                <a
                    onClick={() => setShowAll((prev) => !prev)}
                    style={{
                        alignSelf: "center",
                        justifySelf: "center",
                        textAlign: "center",
                        cursor: "pointer",
                        display: "block"
                    }}
                >
                    {showAll ? "Weniger anzeigen" : "Mehr anzeigen"}
                </a>
            )}
        </div>
    );
}